const ACTIONS = {
    REQUEST_TO_BOOK: 'CHATBOT/REQUEST_TO_BOOK'
};

const ACTION_CREATORS = {
    chatbotRequestToBook() {
        return {
            type: ACTIONS.REQUEST_TO_BOOK,
            payload: {}
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
